import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { consumeWizardReturnTo } from '../../utils/wizardReturnNavigation';

/** Navigate back to the screen the user came from when cancelling the wizard. */
export function useWizardCancelNavigation() {
  const nav = useNavigate();

  return useCallback(() => {
    const returnTo = consumeWizardReturnTo();
    if (returnTo) {
      nav(returnTo);
      return;
    }
    nav(-1);
  }, [nav]);
}
